import React, { memo } from 'react';
import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import styles from './stepperHeader.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(function StepperHeader(props) {
    const [t] = useTranslation('common');

    const qrAndNotFinished = step => step.title === 'QR' && !props.canFinish;
    const completingAndNotQR = step => props.isCompleting && step.title !== 'QR';
    const licence = step => step.title === 'LICENCE' && (!props.completed || props.error);
    const enabled = step => step.title !== 'LICENCE' && step.title !== 'QR' && (props.completed && !props.error);
    const finished = step => step.title !== 'LICENCE' && props.activeStep === 8 && props.completed && !props.error;
    const navigate = index => {
        if (!props.isCompleting) {
            if (index === 6) {
                if (props.canFinish && props.activeStep !== 8) {
                    props.changeStep(index + 1);
                }
            } else if (index === 7) {
                if (props.completed && !props.error) {
                    props.changeStep(index + 1);
                }
            } else if (props.completed) {
                if (props.error) {
                    props.changeStep(index + 1);
                }
            } else {
                props.changeStep(index + 1);
            }
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.stepper}>
                {props.steps.map((step, index) => {
                    return (
                        <div key={index} className={styles.step}>
                            <div
                                className={
                                    conditionalStyles({
                                        selector: true,
                                        selectorAnimation:
                                            !props.isCompleting &&
                                            !qrAndNotFinished(step) &&
                                            !licence(step) &&
                                            !enabled(step) &&
                                            !finished(step),
                                        inactiveSelector:
                                            props.isCompleting ||
                                            qrAndNotFinished(step) ||
                                            licence(step) ||
                                            enabled(step) ||
                                            finished(step)
                                    })
                                }
                                onClick={() => navigate(index)}
                            >
                                <div
                                    className={
                                        conditionalStyles({
                                            activeStepCircle: props.activeStep === index + 1,
                                            inactiveStepCircle:
                                                completingAndNotQR(step) ||
                                                qrAndNotFinished(step) ||
                                                licence(step) ||
                                                enabled(step) ||
                                                finished(step),
                                            circle: props.activeStep !== index + 1,
                                            circleHover:
                                                !props.isCompleting &&
                                                !qrAndNotFinished(step) &&
                                                !licence(step) &&
                                                !enabled(step) &&
                                                !finished(step)
                                        })}
                                >
                                    <div className={styles.contentContainer}>
                                        {(() => {
                                            if (index === 0 && props.activeStep !== index + 1) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/check.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (index === 5 && props.canFinish) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/check.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (index === 6 && props.completed && !props.error) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/check.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (index === 6 && props.completed && props.error) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/close.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (index === 7 && props.activated && !props.activationError) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/check.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (index === 7 && !props.activated && props.activationError) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/close.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (!step.AbleToComplete && props.activeStep !== index + 1) {
                                                return (
                                                    <span>{index + 1}</span>
                                                );
                                            } else if (step.AbleToComplete && !step.Completed &&
                                                props.activeStep !== index + 1) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/close.svg"
                                                        />
                                                    </div>
                                                );
                                            } else if (step.AbleToComplete && step.Completed &&
                                                props.activeStep !== index + 1) {
                                                return (
                                                    <div className={styles.imageContainer}>
                                                        <SVG
                                                            cacheGetRequests={true}
                                                            className={styles.icon}
                                                            src="./icons/check.svg"
                                                        />
                                                    </div>
                                                );
                                            } else {
                                                return (<span>{index + 1}</span>);
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div
                                    className={
                                        conditionalStyles({
                                            title: true,
                                            inactiveStepTitle:
                                                completingAndNotQR(step) ||
                                                qrAndNotFinished(step) ||
                                                licence(step) ||
                                                enabled(step) ||
                                                finished(step)
                                        })
                                    }
                                >
                                    <span>{props.t(step.title)}</span>
                                    {step.Optional && <span className={styles.optionalStep}>{t('common:optional')}</span>}
                                </div>
                            </div>
                            <div className={styles.leftBar}></div>
                            <div className={styles.rightBar}></div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
